import { convertToJpeg } from '@/utils/imageToJpeg';

// Same original-image limit as Templates::ExamplePhotoUpload (25 MiB).
export async function prepareExamplePhoto(file, convert = convertToJpeg) {
  let image = file;
  if (file && (/^image\/(heic|heif)$/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || ''))) {
    const converted = await convert(file, { quality: 0.95 });
    image = converted && converted.file;
  }
  if (!image || !['image/jpeg', 'image/png'].includes(image.type) || image.size < 1 || image.size > 25 * 1024 * 1024) {
    throw new Error('Invalid example photo');
  }
  return image;
}
